import { render } from "./workshopNotice.vue?vue&type=template&id=811dc82c"
import script from "./workshopNotice.vue?vue&type=script&lang=js"
export * from "./workshopNotice.vue?vue&type=script&lang=js"

import "./workshopNotice.vue?vue&type=style&index=0&id=811dc82c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__